const checkAll = function (form) {
    const formH = $(form);
    const el = formH.find(".check-all");
    const name = el.attr('name');
    if (formH.find('input:checkbox:not(.check-all)').length === formH.find('input:checkbox:checked:not(.check-all)').length) {
        el.prop("checked", true);
    }
    formH.find("input:checkbox:not(.check-all)").each(function () {
        const element = $(this);
        element.on('click', function () {
            const iamChecked = element.prop("checked");
            const isChecked = el.prop("checked");
            if (!iamChecked && isChecked) {
                el.prop("checked", false);
            } else if (formH.find('input:checkbox:not(.check-all)').length === formH.find('input:checkbox:checked:not(.check-all)').length) {
                el.prop("checked", true);
            }
        });
    });
    el.on('click', function () {
        const isChecked = el.prop("checked");
        formH.find("input:checkbox").each(function () {
            const element = $(this);
            if (element.attr('name') !== name && isChecked !== element.prop("checked")) {
                element.trigger('click');
            }
        });
    });
};

const radioFormGroupToggle = function (container, group) {
    container.find('[data-val-grp]').each(function() {
        const el = $(this);
        const elGrp = el.data('valGrp');
        el.removeClass('ignore-val-grp is-invalid');
        if(elGrp.indexOf(group) === -1) {
            el.addClass('ignore-val-grp');
        }
    });
    container.find('[data-form-grp]').each(function () {
        const el = $(this);
        const elGrp = el.data('formGrp');
        if (typeof elGrp !== 'undefined') {
            if (elGrp !== group) {
                el.removeAttr('required');
            } else {
                el.prop('required', true);
            }
        }
    });
};

const modernRadioFormGroupToggler = function (rootEl) {
    $(rootEl || document).find('[data-form-grp-toggler="toggler"]').each(function () {
        const el = $(this);
        const container = el.closest('[data-form-grp-toggler="container"]');
        const checked = el.find('input[data-form-grp-toggler]:checked');
        const activeFormGrp = checked.data('formGrpToggler');
        container.attr('data-active-form-grp', activeFormGrp);
        radioFormGroupToggle(container, activeFormGrp);

        container.find('.form-check').removeClass('active');
        checked.closest('.form-check').addClass('active');

        el.find('input[data-form-grp-toggler]')
            .off('click')
            .on('click', function () {
                const clickedEl = $(this);
                const clickedFormGrp = clickedEl.data('formGrpToggler');
                container.attr('data-active-form-grp', clickedFormGrp);
                radioFormGroupToggle(container, clickedFormGrp);

                container.find('.form-check').removeClass('active');
                clickedEl.closest('.form-check').addClass('active');
            });
    });
};

const radioIsCompany = function (form) {
    $(form).find("div[data-is-company=container]").each(function (e, item) {
        const el = $(item);
        if (!el.find("input[data-is-company=private]").is(':checked')) {
            el.closest('[data-is-company=main]').children('.firm-input').show();
            el.closest('[data-is-company=main]').children('.private-input').hide();
        } else {
            el.closest('[data-is-company=main]').children('.firm-input').hide();
            el.closest('[data-is-company=main]').children('.private-input').show();
        }
    });
    $(form).find("input[data-is-company]").on("click", function () {
        if ($(this).data('isCompany') === 'private') {
            $(this).closest('[data-is-company=main]').children('.firm-input').hide();
            $(this).closest('[data-is-company=main]').children('.private-input').show();
        } else {
            $(this).closest('[data-is-company=main]').children('.firm-input').show();
            $(this).closest('[data-is-company=main]').children('.private-input').hide();
        }
    });
};

const modernCheckAll = function () {
    $('[data-app-checkbox=checkAll]').each(function () {
        const el = $(this);
        const form = $(this).closest('form');
        el.on('click', function () {
            const isChecked = el.prop('checked');
            form.find('input:checkbox:not([data-app-checkbox=checkAll])').each(function () {
                const chEl = $(this);
                chEl.prop('checked', isChecked);
            });

        });
        form.find('input:checkbox:not([data-app-checkbox=checkAll])').each(function () {
            const chEl = $(this);
            chEl
                .off('click')
                .on('click', () => {
                    let allChecked = true;
                    form.find('input:checkbox:not([data-app-checkbox=checkAll])').each(function () {
                        if(!$(this).prop('checked')) {
                            allChecked = false;
                            return false;
                        }
                    });
                    el.prop('checked', allChecked);
                });
        });

    });
};

export {
    modernCheckAll,
    radioIsCompany,
    checkAll,
    modernRadioFormGroupToggler,
}
